import { Button } from '@shared/ui/Button';
import { IconBarChart, IconChevronDown } from '@shared/ui/icons';
import { formatMoney } from '../financierFormat';
import {
  CompactSummaryBar,
  CompactSummaryText,
  CompactMetric,
  LiquidityErrorText,
  RetryMiniButton,
} from './styled';
import { STAGE_LABELS, type PipelineMetrics } from './types';

interface CompactSummaryProps {
  pipelineStage: string;
  /** `null` — список заявок не загрузился, сумм нет. */
  metrics: PipelineMetrics | null;
  isDashboardLoading: boolean;
  isDashboardError: boolean;
  availableCash: number | null;
  coveragePct: number | null;
  isRequestsError: boolean;
  onRetryRequests: () => void;
  onExpand: () => void;
}

export function CompactSummary({
  pipelineStage,
  metrics,
  isDashboardLoading,
  isDashboardError,
  availableCash,
  coveragePct,
  isRequestsError,
  onRetryRequests,
  onExpand,
}: CompactSummaryProps) {
  return (
    <CompactSummaryBar>
      <CompactSummaryText>
        <CompactMetric>
          <strong>Этап:</strong> {STAGE_LABELS[pipelineStage] || pipelineStage}
        </CompactMetric>
        <span>|</span>
        <CompactMetric>
          <strong>Утверждено:</strong> {metrics ? formatMoney(metrics.approvedAmount) : '—'}
        </CompactMetric>
        <span>|</span>
        <CompactMetric>
          <strong>Не оплачено:</strong> {metrics ? formatMoney(metrics.unpaidTotal) : '—'}
        </CompactMetric>
        <span>|</span>
        <CompactMetric>
          <strong>Кэш:</strong>{' '}
          {isDashboardLoading
            ? 'Загрузка…'
            : isDashboardError
            ? 'Ошибка'
            : availableCash !== null
            ? formatMoney(availableCash)
            : '—'}
        </CompactMetric>
        {coveragePct !== null ? (
          <>
            <span>|</span>
            <CompactMetric>
              <strong>Покрытие:</strong> {Math.round(coveragePct)}%
            </CompactMetric>
          </>
        ) : (
          isRequestsError && (
            <>
              <span>|</span>
              <LiquidityErrorText>
                Расчёт недоступен: не загрузился список заявок.
                <RetryMiniButton $size="sm" $variant="ghost" onClick={onRetryRequests}>
                  Повторить
                </RetryMiniButton>
              </LiquidityErrorText>
            </>
          )
        )}
      </CompactSummaryText>
      <Button
        $variant="ghost"
        $size="sm"
        onClick={onExpand}
        aria-label="Развернуть блок аналитики"
      >
        <IconBarChart size={14} />
        Развернуть аналитику
        <IconChevronDown size={14} />
      </Button>
    </CompactSummaryBar>
  );
};
